import Server from "helpers/server";
import ElementReplacer from 'helpers/element-replacer';
import Events from 'events/events';
import displayedProductEvent from '../../components/recently-viewed/recently-view-event-dispatcher';

export class Swatch {
  constructor(props) {
    this.loader = document.querySelector('.js-pdp-loader');

    this.state = {
      el: props.el,
      receivedData: true,
      type: props.el.classList.contains('size-link') ? 'size' : 'colour',
      reInit: props.reInit,
      unmountReact: props.unmountReact,
    }
    this.addEventListeners();
  }

  addEventListeners() {
    this.state.el.addEventListener('click', this.handleClick.bind(this));
  }

  updateAnalytics(response) {
    if(window.jlData) window.jlData.page = response.analytics.page;
    document.body.dispatchEvent(new CustomEvent("dataStateChange", {
      detail: {
        action: "pdp.productSkuChanged",
        type: this.state.type
      }
    }));
  }

  displayedProductEventAction(){
    displayedProductEvent(window.jlData.page.productPages.productId, window.jlData.page.productPages.displayedSku);
  }

  handleClick(e) {
    e.preventDefault();

    this.state.receivedData = false;
    this.state.unmountReact();

    const loaderTimeout = setTimeout(() => {
      if(!this.state.receivedData) {
        this.showLoader();
      }
    }, 500);

    const url = this.state.el.pathname + this.state.el.search; // URL and Params for sizes

    Server.getHtml(
      url,
      { method: "GET", credentials: "same-origin" },
    ).then( response => {
      let doc = response.bodyDocument;
      let pageData = response.jsonPageData;
      if(pageData) window.jsonPageData.innerHTML = pageData; // Set JSON Page Data
      window.history.replaceState( null, null, url); // Update URL in browser
      ElementReplacer.replace(doc, 'main'); // Replace Main tag elements
      window.jlSwatchOrder && window.jlSwatchOrder.init();

      this.state.reInit(); // Reinitialise PDP Javascript
      Events.tooltipsReinit.trigger(); // Reinitialise old tooltips
      Events.addToBasketReinit.trigger(); // Reinitialise add to basket JS.
      Events.reviewsReinit.trigger(); // Reinitialise Bazaar Voice Reviews.
      let updateAnalytics = this.updateAnalytics.bind(this);
      updateAnalytics(response); // Update analytics jlData and dispatch custom analytics event with response data.
      let displayedProductEventAction = this.displayedProductEventAction.bind(this);
      displayedProductEventAction();
      this.state.receivedData = true; // Set received data to true so that loader won't run showLoader if loaderTimeout is called.
      clearTimeout(loaderTimeout); // Clear the timeout set on line 38.
      setTimeout(() => {
        window.dispatchEvent(new Event('swatchChanged'))
      }, 500);
    }).catch((err) => {
      console.error(err);
      window.document.location = url; // Force change the document location!
    });
  }

  showLoader() {
    if(this.loader) {
      this.loader.classList.remove('u-hidden');
    }
  }
}
